import React from 'react';
import { Dialog, Box, Typography } from '@mui/material';
import { nameMismatchDetailsModalStyles } from './NameMismatchDetailsModal.styles';

interface NameMismatchDetailsModalProps {
  open: boolean;
  onClose: () => void;
  scenario: 'proprietorship' | 'partnership_company' | 'gst_pan' | 'gst_business';
  expectedName: string;
  chequeName: string;
  panName?: string;
}

export function NameMismatchDetailsModal({
  open,
  onClose,
  scenario,
  expectedName,
  chequeName,
  panName,
}: NameMismatchDetailsModalProps) {
  const labels = {
    proprietorship: ['PAN Name', 'Bank Account Name'],
    partnership_company: ['Firm Name', 'Bank Account Name'],
    gst_pan: ['PAN Number on PAN Card', 'PAN Number on GST'],
    gst_business: ['Firm Name on GST', 'Bank Account Name'],
  }[scenario];
  const title = scenario === 'gst_pan'
    ? 'PAN number Mismatch Details'
    : scenario === 'gst_business'
      ? 'GST name Mismatch Details'
      : 'Name Mismatch Details';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ sx: nameMismatchDetailsModalStyles.paper }}
    >
      <Box sx={nameMismatchDetailsModalStyles.container}>
        <Box sx={nameMismatchDetailsModalStyles.header}>
          <Typography sx={nameMismatchDetailsModalStyles.title}>
            {title}
          </Typography>
          <Box
            onClick={onClose}
            sx={nameMismatchDetailsModalStyles.closeButton}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClose();
              }
            }}
          >
            <svg fill="none" viewBox="0 0 14 14" width="14" height="14">
              <path
                d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
                fill="black"
                fillOpacity="0.56"
              />
            </svg>
          </Box>
        </Box>

        <Box sx={nameMismatchDetailsModalStyles.fieldGroup}>
          <Typography sx={nameMismatchDetailsModalStyles.fieldLabel}>
            {labels[0]}
          </Typography>
          <Typography sx={nameMismatchDetailsModalStyles.fieldValue}>
            {expectedName || panName || '-'}
          </Typography>
        </Box>

        <Box sx={nameMismatchDetailsModalStyles.fieldGroup}>
          <Typography sx={nameMismatchDetailsModalStyles.fieldLabel}>
            {labels[1]}
          </Typography>
          <Typography sx={nameMismatchDetailsModalStyles.fieldValue}>
            {chequeName || '-'}
          </Typography>
        </Box>
      </Box>
    </Dialog>
  );
}
